import { PaymentType } from "../../../../generated/graphql";

export type SubscriptionFormValues = {
  paymentDate: string;
  validity?: string;
  paymentType?: PaymentType | "";
  planId: string;
  pupilsCount?: string;
  teachersCount?: string;
  booksCount?: string;
  total: string;
  paymentTypeId?: string;
  payerId?: string;
  boardsCount?: string;
};

export const BOOKS_PER_TEACHER = 15;

/** Empty, not 0 — 0 is a real limit (the backend blocks every upload on it). */
export const deriveBooksCount = (teachersCount?: string): string => {
  const teachers = Number(teachersCount);

  if (!teachersCount?.trim() || !Number.isInteger(teachers) || teachers <= 0) {
    return "";
  }

  return String(teachers * BOOKS_PER_TEACHER);
};

export const validateForm = (
  values: SubscriptionFormValues,
  isPersonal: boolean
) => {
  const errors: { [key: string]: string } = {};

  const fieldsToSkipInPersonal = ["pupilsCount", "teachersCount", "booksCount"];
  const optionalFields = ["boardsCount", "booksCount"];

  for (let key in values) {
    if (key === "total") continue;
    if (fieldsToSkipInPersonal.includes(key) && isPersonal) continue;
    if (optionalFields.includes(key)) continue;

    if (!values[key]) {
      errors[key] = "Це поле є обов’язковим";
    }
  }

  if (values.total?.length) {
    const trimmedValue = values.total.trim();

    if (!trimmedValue || isNaN(Number(trimmedValue)) || Number(trimmedValue) < 0) {
      errors.total = "Значення повинно бути числом і не менше 0";
    }
  }

  if (values.boardsCount?.length) {
    const raw = values.boardsCount.trim().replace(",", ".");
    const parsed = Number(raw);
    const isNotPositiveInteger = !/^[1-9]\d*$/.test(raw);

    if (isNotPositiveInteger || isNaN(parsed)) {
      errors.boardsCount = "Значення повинно бути додатним цілим числом";
    }
  }

  if (!isPersonal) {
    if (values.validity?.length) {
      if (
        isNaN(Number(values.validity)) ||
        Number(values.validity) < 1 ||
        Number(values.validity) % 1 !== 0
      ) {
        errors.validity = "Значення повинно бути цілим числом >= 1";
      }
    }

    if (
      values.pupilsCount?.length &&
      (isNaN(Number(values.pupilsCount)) || Number(values.pupilsCount) <= 0)
    ) {
      errors.pupilsCount = "Значення повинно бути додатним числом";
    }

    if (
      values.teachersCount?.length &&
      (isNaN(Number(values.teachersCount)) || Number(values.teachersCount) <= 0)
    ) {
      errors.teachersCount = "Значення повинно бути додатним числом";
    }

    if (values.booksCount?.length && !/^\d+$/.test(values.booksCount.trim())) {
      errors.booksCount = "Значення повинно бути цілим числом не менше 0";
    }
  }

  return errors;
};
